import script from "./FAQs.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQs.vue?vue&type=script&setup=true&lang=js"

import "./FAQs.vue?vue&type=style&index=0&id=eb8021a0&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb8021a0"]])

export default __exports__